import { AxiosError } from "axios";
import { toastHandler } from "src/util/toastHandler";

interface ErrorData {
  message?: string;
}

export const axiosErrorHandler = (error: AxiosError<ErrorData>) => {
  const data = error.response?.data;
  const status: number | undefined = error.response?.status;
  if (data?.message || status)
    return toastHandler.error({
      title: `Ошибка ${status ?? ""}`,
      content: data?.message ?? "Непредвиденная ошибка",
      name: "AxiosError",
    });
};
